import { atom } from 'jotai'

export type FilterPaneDirection = 'vertical' | 'horizontal'

export const filterPaneOpenAtom = atom<boolean>(true)
export const filterPaneDirectionAtom = atom<FilterPaneDirection>('horizontal')
